import * as types from '../actions/action-types';

const initialState = {
  firstName: '',
  lastName: '',
};

export default function zippayReducer(state = initialState, action) {
  if (action.type === types.UPDATE_ZIPPAY_FORM) {
    return {
      ...state,
      [action.fieldName]: action.value,
    };
  }
  return state;
}
